export default {
  areas: 'المناطق',
  area: 'المنطقة',
  add: 'إضافة منطقة',
  update: 'تعديل المنطقة',
  details: 'تفاصيل المنطقة'
}
